import { object, string } from '@calendly/form/validation'

export const buildValidationSchema = () => (
  object().shape({
    entity_id: string().required(),
    sso_url: string().url().required(),
    certificate: string().required()
  })
)
